import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import Modal from 'common/components/feedback/Modal'

import Button from '../components/general/Button'
import Icon from '../components/general/Icon'

interface ExplanationModalProps {
  onCancel: () => void
  name: string
  title: string
  description: string
  hideVideo?: boolean
}

const ExplanationModal = ({ name, onCancel, title, description, hideVideo = false }: ExplanationModalProps) => {
  const { t: translate } = useTranslation()
  const adminLink = 'https://www.youtube.com/embed/nB2RnDu-a9I?autoplay=1&mute=0'
  const helperCenterLink = 'https://peoplekeephelp.zendesk.com/hc/en-us'

  return (
    <Modal visible footer={false} closable={true} width={520} onCancel={onCancel} title={`🎉 Hello ${name}`}>
      <Row>
        <Col span={24}>
          <h4>{title}</h4>
        </Col>
      </Row>
      <Row>
        {!hideVideo && (
          <Col span={24} className="mb-16">
            <iframe width="100%" height="265px" src={adminLink}></iframe>
          </Col>
        )}
        <Col span={24} className="mb-16">
          <p>{description}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={18} md={18} lg={18} xl={18}>
          <Button type="primary" onClick={onCancel}>
            Go to the dashboard
          </Button>
        </Col>
        <Col xs={24} sm={6} md={6} lg={6} xl={6} className="mt-8">
          <a href={helperCenterLink} target="_blank" className="help-center-link-explanation-modal">
            <Icon type="far fa-question-circle" fontAwesome /> <span>{translate('user-header.help-center')}</span>
          </a>
        </Col>
      </Row>
    </Modal>
  )
}
export default ExplanationModal
